import clsx from 'clsx';
import React from 'react';
import { polymorphicFactory } from '../../factory/factory.utils.mjs';
import { Box } from '../../Other/Box/Box.mjs';
import { InlineStyles } from '../../Other/InlineStyles/InlineStyles.mjs';
import { removeEmptyProps } from '../../utils/helpers.mjs';
import { parseStyleProps } from '../../utils/styleProps.mjs';
import { useRandomClassName } from '../../utils/hooks/hooks.mjs';
import classes from './Flex.module.css.mjs';
import { FLEX_STYLE_PROPS_DATA } from './Flex.utils.mjs';

const Flex = polymorphicFactory(
  (props, ref) => {
    const { component = "div", className, gap, rowGap, columnGap, align, justify, wrap, direction, style, ...rest } = props;
    const responsiveClassName = useRandomClassName();
    const parsedStyleProps = parseStyleProps({
      styleProps: removeEmptyProps({
        gap,
        rowGap,
        columnGap,
        align,
        justify,
        wrap,
        direction
      }),
      data: FLEX_STYLE_PROPS_DATA
    });
    const classNames = clsx(classes.root, className, "kohler-flex-root", parsedStyleProps.hasResponsiveStyles && responsiveClassName);
    const parsedStyles = {
      ...style,
      ...!parsedStyleProps.hasResponsiveStyles ? parsedStyleProps.inlineStyles : {}
    };
    return /* @__PURE__ */ React.createElement(React.Fragment, null, parsedStyleProps.hasResponsiveStyles && /* @__PURE__ */ React.createElement(InlineStyles, { selector: `.${responsiveClassName}`, styles: parsedStyleProps.styles, media: parsedStyleProps.media }), /* @__PURE__ */ React.createElement(Box, { ref, className: classNames, style: parsedStyles, component, ...rest }));
  }
);

export { Flex };
